import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function BoletosSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisar</h3>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Tipo de Remessa"
            id="TipoDeRemessa"
            optionsArray={[
              '',
              'Contas a Receber/Boleto',
              'Contas a Receber/DA',
              'Contas a Receber/PIX',
              'Contas a Pagar',
            ]}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Conta Bancária"
            id="ContaBancaria"
            optionsArray={['', '999 | 999 | 9999-9 | Caixinha']}
            widthPercentage="45%"
          />
          <SelectAndOptions title="CNAB | Carteira" id="CNABCarteira" optionsArray={['']} widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="45%" />
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={['', 'Todos', 'Não Emitido/Gerado', 'Emitido', 'Gerado']}
            widthPercentage="45%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputDate title="Data Lançamento Inicial" id="DataLancamentoInicial" widthPercentage="20%" />
          <InputDate title="Data Lançamento Final" id="DataLancamentoFinal" widthPercentage="20%" />
          <InputDate title="Vencimento Inicial" id="VencimentoInicial" widthPercentage="20%" />
          <InputDate title="Vencimento Final" id="VencimentoFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
